module.exports = __webpack_public_path__ + "static/media/mall-image-4.00d65c74.png";